import { useEffect, useState } from 'react';
import { loadRuntimeOutbox, RUNTIME_OUTBOX_UPDATED_EVENT } from './outbox';

export function useRuntimeOutbox() {
  const [events, setEvents] = useState(loadRuntimeOutbox);

  useEffect(() => {
    const reload = () => setEvents(loadRuntimeOutbox());
    window.addEventListener('storage', reload);
    window.addEventListener(RUNTIME_OUTBOX_UPDATED_EVENT, reload);
    return () => {
      window.removeEventListener('storage', reload);
      window.removeEventListener(RUNTIME_OUTBOX_UPDATED_EVENT, reload);
    };
  }, []);

  return events;
}
